import React, { useState } from 'react';

const AIChatMinimal = () => {
  const [message, setMessage] = useState('');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);
  const [engineerMode, setEngineerMode] = useState(false);
  const [metrics, setMetrics] = useState<any>(null);

  const sendMessage = async () => {
    if (!message.trim()) return;

    setLoading(true);
    setResponse('');
    setMetrics(null);

    const startTime = performance.now();

    try {
      const res = await fetch('https://futr-bet-api.b-9f2.workers.dev/api/ai/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message, engineerMode })
      });

      const endTime = performance.now();
      const data = await res.json();

      if (data.success) {
        setResponse(data.response);

        // Engineer metrics
        if (engineerMode && data.metrics) {
          setMetrics({
            ...data.metrics,
            totalTime: Math.round(endTime - startTime),
            timestamp: new Date().toISOString()
          });
        }
      } else {
        setResponse('Error: ' + (data.error || 'Unknown error'));
      }
    } catch (error) {
      setResponse('Failed to connect to chat');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed bottom-4 right-4 w-80 bg-black border border-green-400 rounded-lg p-4 z-50">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-green-400 font-bold">AI Chat {engineerMode && '🔧'}</h3>
        <button
          onClick={() => setEngineerMode(!engineerMode)}
          className="text-xs text-yellow-400 hover:text-yellow-300"
        >
          {engineerMode ? 'Normal' : 'Engineer'}
        </button>
      </div>

      {engineerMode && metrics && (
        <div className="mb-2 p-2 bg-gray-900 border border-yellow-400 rounded text-xs text-yellow-400 font-mono">
          <div>📡 Model: {metrics.model || 'llama-2-7b'}</div>
          <div>⚡ Response: {metrics.aiTime || 0}ms</div>
          <div>💾 DB Write: {metrics.dbTime || 0}ms</div>
          <div>🌐 Total: {metrics.totalTime}ms</div>
          <div>🔤 Tokens: {metrics.tokens || 'N/A'}</div>
          <div>🆔 Chat ID: {metrics.chatId}</div>
        </div>
      )}

      {response && (
        <div className="mb-3 p-2 bg-gray-900 text-green-300 rounded text-sm">
          <div dangerouslySetInnerHTML={{
            __html: response
              .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
              .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" class="underline text-green-400 hover:text-green-300">$1</a>')
              .replace(/\n/g, '<br/>')
          }} />
        </div>
      )}

      <div className="flex gap-2">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
          placeholder="Type a message..."
          className="flex-1 bg-gray-900 text-green-400 px-2 py-1 rounded border border-green-400 text-sm"
          disabled={loading}
        />
        <button
          onClick={sendMessage}
          disabled={loading || !message.trim()}
          className="bg-green-600 text-white px-3 py-1 rounded text-sm disabled:opacity-50"
        >
          {loading ? '...' : 'Send'}
        </button>
      </div>
    </div>
  );
};

export default AIChatMinimal;